// Dauber HQ — Showcase view switcher (Caller ↔ Players), scoped per [data-view-group].

(function () {
  'use strict';

  var btns = document.querySelectorAll('[data-view-btn]');
  if (!btns.length) return;

  btns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.getAttribute('data-view-btn');
      var scope = btn.closest('[data-view-group]') || document;

      scope.querySelectorAll('[data-view-btn]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      scope.querySelectorAll('[data-view-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-view-panel') !== target;
      });
    });
  });
})();
